<template>
  <v-checkbox v-model="checkbox" :label="labelV" :rules="rules" :color="color" dense>
  </v-checkbox>
</template>

<script>
export default {
  name: "RyouCheckbox",
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: [Boolean,Array],
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: ""
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      labelV: ""
    };
  },
  methods: {},
  mounted() {
    this.labelV = this.label// + " : " + this.value.toString();     //true false �\�L���\���ɂ���
  },
  //watch: {                                                        //true false �\�L���\���ɂ���
  //  checkbox(val) {
  //    this.labelV = this.label + " : " + val.toString();
  //  }
  //},
  computed: {
    checkbox: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style>
</style>
